import HeaderContent from "component/layout/HeaderContent";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function TimelinePageRouter() {
  const navigate = useNavigate();
  const onChangeToTimeline = () => {
    navigate("/timeline");
  };

  return (
    <HeaderContent>
      {/* <TopHeader  isChangeIcon onClickChangeIcon={onChangeToTimeline}/> */}

      {/* <TimelineGraphPage /> */}
    </HeaderContent>
  );
}
